import NotificationTable from './NotificationTable';

export default NotificationTable;
